export function  getBaseImagePath() {
    return process.env.REACT_APP_BASE_DOMAIN || ''
}